import { Component } from "react";
import Window from "../ui/Window";
import { BsSignStopFill } from "react-icons/bs";
import BasicDataGrid from "../ui/BasicDataGrid";
import { Box, Stack } from "@mui/system";
import { Card, Chip, CircularProgress, Grid, IconButton, Typography } from "@mui/material";
import { MdCalendarViewWeek, MdOutlineWarehouse, MdWarehouse } from "react-icons/md";
import DepositoFicha from "./DepositoFicha";
import { httpGet } from "../util/http";
import { INVENTARIO_CONCLUIDO } from "../util/contants";
import DashStatus from "../ui/DashStatus";
import Cookies from "universal-cookie";
import DepositoFichaSemanal from "./DepositoFichaSemanal";
import { TbReportAnalytics } from "react-icons/tb";
import { Navigate } from "react-router-dom";

export default class Semanal extends Component {

    constructor(props) {
        super(props);
        let cookies = new Cookies();
        this.user = cookies.get('user');
        this.state = {
            loading: false,
            showDepFicha: false,
            showUnidFicha: false,
            depositos: [],
            currDeposito: null,
            toRelatorioSemanal: false,
        };
    }

    onDepFichaClick(e, deposito) {
        e.stopPropagation();
        this.setState({ showDepFicha: true, currDeposito: deposito });
    }

    componentDidMount() {
        this.refresh(false);
    }

    refresh(statsRefresh) {
        this.setState({ loading: true });
        httpGet('/unidades/list',
            unidades => {
                let depositos = [];
                console.log(unidades)
                unidades.forEach(unidade => {
                    unidade?.depositos.forEach(dep => {
                        if (!dep.nome.includes('99')) {
                            depositos.push(dep);
                        }
                    });
                });
                this.setState({
                    depositos,
                    loading: false,
                    statsKey: new Date().valueOf()
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
            false
        );
    }

    render() {
        return (
            <>
                {
                    <Window full title="Contagem Semanal" icon={MdCalendarViewWeek}>
                        {this.state.showDepFicha && <DepositoFichaSemanal onRefresh={() => this.refresh(true)} deposito={this.state.currDeposito} onClose={e => this.setState({ showDepFicha: false })} />}
                        {this.user.isAdmin && <Box mt={1} bgcolor='mariano.secondary' borderRadius={2} justifyContent="center"><IconButton onClick={() => this.setState({ toRelatorioSemanal: true })} color="primary" title="Relatório de desempenho"><TbReportAnalytics size={20} /></IconButton></Box>}
                        <Typography mt={1} fontSize={11}>Selecione um depósito para iniciar a contagem semanal.</Typography>
                        {(this.state.depositos.length == 0) ?
                            <Stack alignItems="center" justifyContent="center" height="100%">
                                <CircularProgress />
                            </Stack>

                            :
                            <Grid mt={3} container gap={1} overflow="scroll">
                                {this.state.depositos.map((dep) =>
                                    <Stack key={dep.id} borderRadius={2} color="white" alignItems="center" justifyContent="center" onClick={e => this.onDepFichaClick(e, dep)} sx={{ cursor: 'pointer' }} width={175} height={175} bgcolor={dep.status2 == INVENTARIO_CONCLUIDO ? "#2e7d32" : "#d32f2f"}>
                                        <MdWarehouse size={50} />
                                        <Typography textAlign="center" fontSize={25}><b>{dep?.nome}</b></Typography>
                                    </Stack>
                                )}
                            </Grid>
                        }
                    </Window>
                }
                {this.state.toRelatorioSemanal && <Navigate to='/relatoriosemanal' />}
            </>
        );
    }
}
